import { render } from "./formation-page.vue?vue&type=template&id=6ea6df7e"
import script from "./formation-page.vue?vue&type=script&lang=js"
export * from "./formation-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__